<template>
	<div>
		<main-header :class="{'h-bg': $route.path !== '/'}"></main-header>
		<div :class="{h: $route.path !== '/'}">
			<router-view />
		</div>
		<main-footer></main-footer>
		<div id="clan-slider">
			<ul>
				<li class="hidden-xs">
					<a id="slider-wechat" href="javascript:void(0);"></a>
					<div class="clan-slider-tips-wechat" style="display: none;">
						<img src="~@/assets/img/common/WechatIMG2942.jpg">
					</div>
				</li>
			</ul>
		</div>
		<div id="m-clan-slider">
			<ul>
				<li class="visible-xs">
					<a id="slider-wechat" href="javascript:void(0);"></a>
					<div class="clan-slider-tips-wechat" style="display: none;">
						<img src="~@/assets/img/common/WechatIMG2942.jpg">
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import Components from '@/components/layouts'
	export default {
		name: 'MainLayout',
		components: {
			...Components
		},
		mounted() {
			// 用于侧边栏
			document.querySelectorAll("#clan-slider li").forEach(li => {
				li.addEventListener("mouseover", () => {
					li.querySelector('div').style.display = 'block'
				})
				li.addEventListener("mouseout", () => {
					li.querySelector('div').style.display = 'none'
				})
			})
			document.querySelectorAll("#m-clan-slider li").forEach(li => {
				li.addEventListener("click", () => {
					const currentDiv = li.querySelector('div');
					document.querySelectorAll("#m-clan-slider li div").forEach(div => {
						if (div !== currentDiv) {
							div.style.display = 'none'; // 隐藏其他 div
						}
					});
					li.querySelector('div').style.display = li.querySelector('div').style.display === 'block' ? 'none' : 'block'
				})
			})
		}
	}
</script>

<style lang="scss">
	.h {
		padding-top: 80px;
	}
	.h-bg {
		background-color: rgb(31, 63, 67) !important;
	}
	@media screen and (max-width: 768px) {
		.h {
			padding-top: 60px;
		}
	}
	
	#clan-slider {
		position: fixed;
		_position: absolute;
		bottom: 45%;
		right: .1%;
		z-index: 1000;
	}

	#clan-slider ul {
		margin: 0;
		padding: 0;
		margin-top: -2px;
		list-style: none;
	}

	#clan-slider ul li {
		display: block;
		margin: 0;
		padding: 0;
		margin-top: 2px;
		position: relative;
	}

	#clan-slider ul li a {
		display: block;
		overflow: hidden;
		width: 48px;
		height: 48px;
		border: 1px solid #0ba1e4;
		background-color: #f5f5f5;
		background-image: url(~@/assets/img/common/clan-slider.png);
		background-repeat: no-repeat;
	}

	#slider-chat {
		background-position: 0 -92px;
	}

	#clan-slider #slider-chat:hover {
		background-position: -46px -92px;
		background-color: #0ba1e4;
	}

	#slider-qq {
		background-position: 0 -138px;
	}

	#clan-slider #slider-qq:hover {
		background-position: -46px -138px;
		background-color: #0ba1e4;
	}

	#slider-phone {
		background-position: 0 -184px;
	}

	#clan-slider #slider-phone:hover {
		background-position: -46px -184px;
		background-color: #0ba1e4;
	}

	#slider-wechat {
		background-position: 0 -230px;
	}

	#clan-slider #slider-wechat:hover {
		background-position: -46px -230px;
		background-color: #0ba1e4;
	}

	#clan-slider .clan-slider-tips {
		position: absolute;
		top: 0px;
		right: 48px;
		display: none;
		height: 48px;
		padding-left: 10px;
		padding-right: 2px;
		white-space: nowrap;
		border: 1px solid #0ba1e4;
		background-color: #0ba1e4;
		text-align: center;
		line-height: 48px;
		font-size: 18px;
		color: #fff;

	}

	#clan-slider .clan-slider-tips-wechat,
	#clan-slider .clan-slider-tips-wechat-offical-account {
		display: none;
		position: absolute;
		padding: 1px;
		bottom: 50%;
		right: 50px;
		transform: translateY(50%);
	}

	#clan-slider .clan-slider-tips-wechat img {
		width: 196px;
		aspect-ratio: 388 / 478;
		border: 1px solid #f3f3f3;
	}

	#clan-slider .clan-slider-tips-wechat-offical-account img {
		height: 100px;
		aspect-ratio: 285 / 104;
	}

	@media screen and (max-width: 768px) {
		.hidden-xs {
			display: none !important;
		}
	}

	#m-clan-slider {
		position: fixed;
		_position: absolute;
		bottom: 45%;
		right: .1%;
		z-index: 1000;
	}

	#m-clan-slider ul {
		margin: 0;
		padding: 0;
		margin-top: -2px;
		list-style: none;
	}

	#m-clan-slider ul li {
		display: block;
		margin: 0;
		padding: 0;
		margin-top: 2px;
		position: relative;
	}

	#m-clan-slider ul li a {
		display: block;
		overflow: hidden;
		width: 48px;
		height: 48px;
		border: 1px solid #0ba1e4;
		background-color: #f5f5f5;
		background-image: url(~@/assets/img/common/clan-slider.png);
		background-repeat: no-repeat;
	}

	#m-clan-slider .clan-slider-tips {
		position: absolute;
		top: 0px;
		right: 48px;
		display: none;
		height: 48px;
		padding-left: 10px;
		padding-right: 2px;
		white-space: nowrap;
		border: 1px solid #0ba1e4;
		background-color: #0ba1e4;
		text-align: center;
		line-height: 48px;
		font-size: 18px;
		color: #fff;

	}

	#m-clan-slider .clan-slider-tips-wechat,
	#m-clan-slider .clan-slider-tips-wechat-offical-account {
		display: none;
		position: absolute;
		padding: 1px;
		bottom: 50%;
		right: 50px;
		transform: translateY(50%);
	}

	#m-clan-slider .clan-slider-tips-wechat img {
		width: 196px;
		aspect-ratio: 388 / 478;
		border: 1px solid #f3f3f3;
	}

	#m-clan-slider .clan-slider-tips-wechat-offical-account img {
		height: 100px;
		aspect-ratio: 285 / 104;
	}

	@media screen and (min-width: 768px) {
		.visible-xs {
			display: none !important;
		}
	}
</style>